export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyBGXCPg4b7Ky-djslH6lWM8h4dp3hfmj5o",
    authDomain: "liumex.firebaseapp.com",
    databaseURL: "https://liumex-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "liumex",
    storageBucket: "assets.liumex.com",
    messagingSenderId: "472208918985",
    appId: "1:472208918985:web:ead1cac16d56bbe2514018",
    measurementId: "G-88PMHRJQ4W",
  },
  notificationDuration: 3500,
  assetDomain: "https://assets.liumex.com/",
  authUrl: "https://account.liumex.com/auth?redirectTo=",
  emsDatabaseURL: "https://esportsms.europe-west1.firebasedatabase.app",
  placeholderImage: "https://assets.liumex.com/resources/esportsms/content/placeholder-img.png",
  placeholderTeamLogo: "https://assets.liumex.com/resources/esportsms/content/placeholder-team.png",
  placeholderPersonImage: "https://assets.liumex.com/resources/esportsms/content/placeholder-player.png",
  armrestOnImage: "https://assets.liumex.com/resources/esportsms/content/s/armrest-on.png",
  armrestOffImage: "https://assets.liumex.com/resources/esportsms/content/s/armrest-off.png",
  pillowOnImage: "https://assets.liumex.com/resources/esportsms/content/s/pillow-on.png",
  pillowOffImage: "https://assets.liumex.com/resources/esportsms/content/s/pillow-off.png",
  inearsOnImage: "https://assets.liumex.com/resources/esportsms/content/s/inears-on.png",
  inearsOffImage: "https://assets.liumex.com/resources/esportsms/content/s/inears-off.png",
  nationalFlagUrl: "https://assets.liumex.com/resources/esportsms/content/f/",
};